import {
	Backdrop,
	createStyles,
	Fade,
	makeStyles,
	Modal,
	Theme,
} from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { TextsProps } from "../../../database/txt.interface";
import { AppActions } from "../../../store/ducks/app";
import { Container } from "./styles";
import DinoHappy from "../../../assets/dinoHappyAsync.svg";
import history from "../../../routes/history";
import moment from "moment";
import { persistStorage } from "../../../utils/base_async_storage";
import { PacientesProps } from "../../../interfaces/pacientes.interface";
import { AddPacAvalActions } from "../../../store/ducks/add_pac_aval";
import InputSelectForm from "../../SelectComponent/InputSelectForm";
import { useForm } from "react-hook-form";
import { FormHandles } from "@unform/core";
import Form from "../../../components/Form";
import FormSubmiteButton from "../../Buttons/FormSubmitButton";
import { formatDominant, formatDominantForSave } from "../../../utils/funcs";
import { AmplitudeLog } from "../../../utils/amplitude";

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		modal: {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
		},
		paper: {
			backgroundColor: theme.palette.background.paper,
			border: "0",
			boxShadow: theme.shadows[5],
		},
	})
);

const ModalLadoDominante: React.FC = () => {
	const dispatch = useDispatch();
	const current_language: TextsProps = useSelector(
		(state: any) => state.configs.current_language
	);
	const classes = useStyles();
	const visible_modal =  useSelector(
		(state: any) => state.app.is_open_select_dominant_side
	);
	const patient: PacientesProps = useSelector(
		(state: any) => state.app.is_open_paciente
	);

	const user_eval_avatar_64 =  useSelector((state: any) => state.add_pac_aval.user_eval_avatar_64);

	const DominantSides = [
		current_language?.canhoto,
		current_language?.destro,
	];
	const [dominantSup, setDominantSup] = useState<string>("");
	const [dominantInf, setDominantInf] = useState<string>("");
	const [load, setLoad] = useState(false);
	
	const methods = useForm();
	const formRef = useRef<FormHandles>(null);
	const values = methods.getValues();

	const editPatient = (data: any) => {
			const dat_request = {	
				...patient,
				USUARIO_LADO_DOMINANTE: formatDominantForSave(data.EditLadoDominanteSup, current_language),
				USUARIO_LADO_DOMINANTE_INF: formatDominantForSave(data.EditLadoDominanteInf, current_language),
			};
			dispatch(AddPacAvalActions.set_avatar_eval_64(user_eval_avatar_64 != null ? user_eval_avatar_64 : patient?.USUARIO_FOTO));
			AmplitudeLog('edit_perfil_paciente', {body: dat_request})
			dispatch(AddPacAvalActions.set_edit_paci(patient));
			dispatch(AddPacAvalActions.request_add_evaluetor(dat_request));
			dispatch(AppActions.set_modal_select_dominant_side(false));

		};


	useEffect(() => {
		methods.setValue("EditLadoDominanteSup", formatDominant(patient?.USUARIO_LADO_DOMINANTE, current_language));
		methods.setValue("EditLadoDominanteInf", formatDominant(patient?.USUARIO_LADO_DOMINANTE_INF, current_language));
	}, [patient]);

	return (
		<div>
			<Modal
				aria-labelledby="transition-modal-title"
				aria-describedby="transition-modal-description"
				className={classes.modal}
				open={visible_modal}
			>
				<Fade in={visible_modal}>
					<Container>
						<Form
							ref={formRef}
							methods={methods}
							onSubmit={(data) => {
								editPatient(data), setLoad(true);
							}}
						>
							<div className="divText">
								<h1 className="title">
									{current_language?.informacoes_obrigatorias}
								</h1>
								<InputSelectForm
									type="select"
									title={current_language?.lado_dominante_superiores}
									descriptionTitle={current_language?.lado_mao}
									placeholder={current_language?.selecione}
									rightIcon="ArrowSelect"
									arrayOptions={DominantSides}
									fontFamily="NotoSans-SemiBold"
									fontWeight={600}
									fontSize={1}
									marginTop={20}
									typeInputName="EditLadoDominanteSup"
									dataChildToParent={(data) => {
										setDominantSup(data);
									}}
								/>
								<InputSelectForm
									type="select"
									title={current_language?.lado_dominante_inferiores}
									descriptionTitle={current_language?.lado_perna}
									placeholder={current_language?.selecione}
									rightIcon="ArrowSelect"
									arrayOptions={DominantSides}
									fontFamily="NotoSans-SemiBold"
									fontWeight={600}
									fontSize={1}
									marginTop={20}
									typeInputName="EditLadoDominanteInf"
									dataChildToParent={(data) => {
										setDominantInf(data);
									}}
								/>
								<div style={{
									marginTop: '4.8rem',
									width: '100%'
								}}>
									<FormSubmiteButton
										type="submit"
										onClick={()=> {
											methods.trigger();
										}}
										disabled={!!dominantSup && !!dominantInf ? false : true}
										marginTop={4}
										fontFamily="Kanit-Medium"
										typeButtonComponent="primary"
										title={!load && current_language?.salvar_edicao || current_language?.loading}
									/>
								</div>
							</div>
						</Form>
					</Container>	
				</Fade>
			</Modal>
		</div>
	);
};

export default ModalLadoDominante;